import { io, Socket } from 'socket.io-client';
import { BotConfig } from '../types';

const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || 'http://betclas.net:3005';

class SocketService {
  private socket: Socket | null = null;

  connect(): Socket {
    if (!this.socket) {
      this.socket = io(SOCKET_URL, {
        autoConnect: true,
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionAttempts: 5,
      });

      this.socket.on('connect', () => {
        console.log('Socket connected:', this.socket?.id);
      });

      this.socket.on('disconnect', () => {
        console.log('Socket disconnected');
      });

      this.socket.on('error', (error: any) => {
        console.error('Socket error:', error);
      });
    }

    return this.socket;
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  subscribeToBotStatus(callback: (bots: BotConfig[]) => void): void {
    if (!this.socket) this.connect();
    
    this.socket?.on('bot-status-update', callback);
    this.socket?.emit('subscribe-bot-status');
  }

  subscribeToLogs(botName: string, callback: (data: { botName: string; logs: string }) => void, lines?: number): void {
    if (!this.socket) this.connect();
    
    this.socket?.on('logs-update', callback);
    this.socket?.emit('subscribe-logs', { botName, lines });
  }

  unsubscribeFromBotStatus(): void {
    this.socket?.off('bot-status-update');
  }

  unsubscribeFromLogs(): void {
    this.socket?.off('logs-update');
  }

  getSocket(): Socket | null {
    return this.socket;
  }
}

export const socketService = new SocketService();
export default socketService;
